import * as React from 'react';
import { UomConversionProps } from 'app/area/codetable/item/uom-conversion/types';
import { UomConversionItem } from 'app/area/codetable/item/uom-conversion/uom-conversion-item';

export const UomConversionItems = (props: UomConversionProps) => {
  const { uomConversionFactors} = props;

  return <div className="row">
    {uomConversionFactors?.map(item => <UomConversionItem key={item.value} {...props} item={item} />)}
  </div>;
};
